(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["PRODUCT-INFO"]) return;
  try {
    
document.addEventListener('click', function (event) {
  const swatch = event.target.closest('[data-color-swatch]');
  if (!swatch) return;

  const root = swatch.closest('[data-color-swatch-root]');
  if (!root) return;

  // Active state
  root.querySelectorAll('[data-color-swatch].is-active').forEach(function (el) {
    el.classList.remove('is-active');
  });
  swatch.classList.add('is-active');

  const color = swatch.getAttribute('data-color') || '';
  const label = root.querySelector('[data-color-label]');
  if (label) {
    label.textContent = color;
  }

  const variantId = swatch.getAttribute('data-variant-id');
  const productSection = swatch.closest('.product-information');
  if (!productSection) return;

  // Try to sync with radios like "options[Color]"
  let matched = false;
  const radios = productSection.querySelectorAll('input[type="radio"][name^="options["]');
  radios.forEach(function (radio) {
    if (radio.value && radio.value.toLowerCase() === color.toLowerCase()) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      matched = true;
    }
  });

  // Fallback to select[name="id"] if needed
  if (!matched && variantId) {
    const select = productSection.querySelector('select[name="id"]');
    if (select) {
      select.value = variantId;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
